module.exports = __webpack_public_path__ + "static/media/logoBerwarna.189fa653.png";